import React from "react";
import { scaleColors } from "../MatchRank/MatchRank";

interface ProgressBarProps {
  percentageComplete: number;
  className?: string;
  fill?: string;
}

// TODO - add animation?
export const ProgressBar: React.FC<ProgressBarProps> = ({
  percentageComplete,
  className,
  fill = "#F5F5F5",
}) => {
  let color = scaleColors.maxLevel;
  if (percentageComplete < 50) color = scaleColors.weakLevel;
  else if (percentageComplete < 90) color = scaleColors.midLevel;

  return (
    <div className={`ProgressBarContainer ${className ? className : ""}`}>
      <div className="ProgressBar FillColour">
        {fill ? (
          <div
            className="Filled"
            style={{
              width: "100%",
              backgroundColor: fill,
              position: "absolute",
            }}
          />
        ) : null}
        <div
          className="Filled"
          style={{
            width: `${percentageComplete}%`,
            zIndex: 2,
            position: fill ? "absolute" : "static",
            backgroundColor: color,
          }}
        />
      </div>
    </div>
  );
};
